module.exports = {
  // 开发
  development: {
    BASE_URL: "http://yfsb-test.xkw.com",
    loginUrl: "https://t.zxxk.com",
  },
  // 测试
  test: {
    BASE_URL: "http://yfsb-test.xkw.com",
    loginUrl: "https://t.zxxk.com",
  },
  // 生产
  production: {
    BASE_URL: "http://gateway-jqzy.zxxk.com",
    loginUrl: "https://sso.zxxk.com",
  },
};
